namespace $.$$ {

	$mol_style_define( $shm_hitalama_taskmanager_column, {
		flex: {
			direction: 'column',
			basis: '35rem',
			// grow: 1,
			// shrink: 1,
		},
		minWidth: 0,
		minHeight: '28rem',
		background: {
			color: $mol_theme.card,
		},
		border: {
			radius: '8px',
		},
		boxShadow: '0 0 0 1px ' + $mol_theme.line,
		padding: 0,

		Head: {
			alignItems: 'center',
			justifyContent: 'space-between',
			gap: $mol_gap.text,
			minHeight: '2rem',
		},

		Title: {
			alignItems: 'center',
			gap: $mol_gap.text,
			font: {
				weight: 600,
			},
			padding: {
				top: 0,
				bottom: 0,
			},
		},

		Count: {
			minWidth: '1.75rem',
			minHeight: '1.75rem',
			alignItems: 'center',
			justifyContent: 'center',
			border: {
				radius: '999px',
			},
			background: {
				color: $mol_theme.hover,
			},
			color: $mol_theme.shade,
			font: {
				size: '13px',
			},
		},

		Tools: {
			margin: {
				left: 'auto',
			},
		},

		Add: {
			gap: '6px',
			minHeight: '2rem',
			justifyContent: 'center',
		},

		Raw: {
			width: '100%',
			minHeight: '20rem',
		},

		Tasks: {
			flex: {
				direction: 'column',
				grow: 1,
				shrink: 1,
			},
			minHeight: 0,
			gap: $mol_gap.text,
		},
	} )

}
